import { render, staticRenderFns } from "./IdentificationEditView.vue?vue&type=template&id=0bde16de&"
import script from "./IdentificationEditView.vue?vue&type=script&lang=ts&"
export * from "./IdentificationEditView.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationEditView.vue?vue&type=style&index=0&id=0bde16de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports